<template>
    <div class="page-container">

       	<div class="page-header" :class="{ 'active' : showPageHeader }">

    		<div class="container-fluid">
    			<div class="page-title">{{ pageTitle }}</div>
    		</div>

    	</div>

        <div class="form-message" :class="{ 'active' : successAccount }">Uppgifterna är sparade.</div>
        <div class="form-message" :class="{ 'active' : successPassword }">Lösenordet är ändrat.</div>

    	<div class="page-body" v-if="fetcher.initialized">

    		<div class="container-fluid">
    			<h1>{{ pageTitle }}</h1>
                <p>Här kan du ändra dina uppgifter och ditt lösenord. Behöver du hjälp? Se Hjälp & FAQ.</p>

                <form action="#" @submit.prevent="patcherPatch()" class="mt-6">

                    <div class="mb-4" :key="field.id" v-for="field in dynamic_fields" v-if="field.type !== 'password'">
                        <input-text
                            :type="field.input_type"
                            :name="'dynamic_fields_data.'+field.id+'.value'"
                            :label="field.label"
                            :required="field.is_required"
                            v-model="dynamic_fields_data[field.id].value"
                            v-if="field.type !== 'workplace_id'"
                            :floatLabel="true"
                        />
                        <input-select
                            :name="'dynamic_fields_data.'+field.id+'.value'"
                            :label="field.label"
                            :required="field.is_required"
                            v-model="dynamic_fields_data[field.id].value"
                            :options="workplaces"
                            v-if="field.type === 'workplace_id'"
                            :floatLabel="true"
                        />
                    </div>

                    <input type="submit" value="Spara ändringar" class="btn btn-primary w-100" :class="{ 'loading' : patcher.submitted }" :disabled="patcher.submitted">

                </form>

                <hr class="mt-7 mb-7">

                <h1>Ändra lösenord</h1>

                <form action="#" @submit.prevent="posterPost()" class="mt-4">

                    <input-text
                        type="password"
                        name="password"
                        label="Nytt lösenord"
                        v-model="password"
                        :floatLabel="true"
                        customErrorMessage="Vänligen ange ett korrekt lösenord, med både bokstäver och siffror och minst 8 tecken."
                        form-group-class="mb-4"
                    />

                    <input type="submit" value="Ändra lösenord" class="btn btn-primary w-100" :class="{ 'loading' : poster.submitted }" :disabled="poster.submitted">

                </form>

                <hr class="mt-7 mb-7">

                <a class="d-block w-100" style="color:#999;" @click="logout()">
                    Logga ut från detta konto
                    <img src="/images/card/logout-icon.svg" style="float:right; height: 24px;">
                </a>

            </div>

    	</div>

    </div>
</template>

<script>
import axios from 'axios'

import scrollMixin from '../../../shared/mixins/scrollMixin'
import employeeDynamicFields from '../../../shared/mixins/employee-dynamic-fields'
import fetcher from '../../../shared/mixins/fetcher'
import patcher from '../../../shared/mixins/patcher'
import poster from '../../../shared/mixins/poster'

export default {

    mixins: [
        scrollMixin,
        employeeDynamicFields,
        fetcher,
        patcher,
        poster
    ],

    data () {
        return {
            pageTitle: 'Mitt konto',
            showPageHeader: false,

            employee: null,
            workplaces: [],
            dynamic_fields: [],
            fetcher: {
                autoFill: [
                    'employee',
                    'workplaces',
                    'dynamic_fields'
                ]
            },

            password: '',

            hasErrors: false,
            loadingAccount: false,
            loadingPassword: false,
            successAccount: false,
            successPassword: false
        }
    },

    computed: {
        fetcherUrl () {
            return '/account'
        },
        patcherUrl () {
            return '/account/' + this.employee.id
        },
        patcherData () {
            return {
                dynamic_fields_data: this.dynamic_fields_data
            }
        },
        posterUrl () {
            return '/account/password'
        },
        posterData () {
            return {
                password: this.password
            }
        }
    },

    methods: {

        fetcherSuccess () {
            this.resetDynamicFieldData()
        },

        patcherSuccess () {
            this.successAccount = true

            setTimeout(() => {
                this.successAccount = false
            }, 5000)
        },

        posterSuccess () {
            this.successPassword = true

            setTimeout(() => {
                this.successPassword = false
            }, 5000)
        },

        logout () {
            axios.post('/logout').then(() => {
                window.location.href = '/'
            })
        }

    }
}
</script>
